// hooks/useAnimationObserver.js
import { useEffect } from 'react';

export const useAnimationObserver = (classNames, options = { threshold: 0.3 }) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);

          if (entry.target.classList.contains('anim-slide-long4')) {
            let animTime = 0;
            Array.from(entry.target.childNodes).forEach((element) => {
              if (element.nodeName === 'LI') {
                setTimeout(() => {
                  element.classList.add('anim-slide2');
                }, animTime);
                animTime += 350;
              }
            });
          }

          if (entry.target.classList.contains('anim-slide-long5')) {
            let animTime = 0;
            Array.from(entry.target.childNodes).forEach((element) => {
              if (element.nodeName === 'LI') {
                setTimeout(() => {
                  element.classList.add('anim-slide2');
                }, animTime);
                animTime += 350;
              }
            });
          }

          if (entry.target.classList.contains('anim-slide-long8')) {
            setTimeout(() => {
              document.querySelectorAll('.counter-two').forEach((counter) => {
                const target = Number(counter.dataset.count);
                if (target && target > 0) {
                  let current = 0;
                  const duration = 200;
                  const step = target / duration;

                  const update = () => {
                    current += step;
                    const value = Math.ceil(current);

                    if (current < target) {
                      counter.textContent = new Intl.NumberFormat('ru-RU').format(value);
                      requestAnimationFrame(update);
                    } else {
                      counter.textContent = new Intl.NumberFormat('ru-RU').format(target);
                    }
                  };

                  update();
                }
              });
            }, 300);
          }
        }
      });
    }, options);

    const selector = classNames.map((className) => `.${className}`).join(', ');
    const elements = document.querySelectorAll(selector);

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [classNames.join(','), JSON.stringify(options)]);
};
